<template>
  <!-- Full-screen error state — the single design behind error.vue and the
       static /403 and /404 pages (which exist because SPA-mode middleware can't
       `showError` reliably; see middleware/05.access.global.ts). Copy comes in
       as props so each entry point stays a thin wrapper; actions are a slot
       because their handlers differ per surface (e.g. error.vue must
       `clearError()` before anything else). -->
  <div
    class="h-screen w-screen bg-surface-100 px-8 flex justify-center items-start flex-col gap-2 text-surface-800"
  >
    <h1 class="text-5xl font-bold">{{ title }}</h1>
    <h2 class="text-xl font-medium">{{ subtitle }}</h2>
    <span v-if="statusCode"
      >Yeah, I'd say that's a
      <span class="font-semibold">{{ statusCode }}.</span></span
    >
    <span
      v-if="description"
      class="text-sm"
      >{{ description }}</span
    >
    <div class="flex gap-2 mt-2">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  subtitle: string
  statusCode?: number
  description?: string
}>()
</script>
